<div class="cap-alerts-connect-tab tw-flex tw-flex-col tw-gap-6">
  <div class="tw-flex tw-items-center tw-gap-4">
    <span class="cap-alerts-connect-tab__tile" aria-hidden="true">
      <mat-icon svgIcon="link" />
    </span>
    <h3 class="cap-alerts-connect-tab__title">
      Connect your CAP Alert provider
    </h3>
  </div>

  <section
    class="tw-flex tw-flex-col tw-gap-2"
    aria-labelledby="capAddressHeading"
  >
    <h4 id="capAddressHeading" class="cap-alerts-connect-tab__label">
      Paste address into your CAP provider
    </h4>
    <p id="capAddressHelper" class="cap-alerts-connect-tab__helper">
      Copy this unique address and paste it directly inside your third-party CAP
      provider's outgoing configuration screen.
    </p>

    <div class="cap-alerts-connect-tab__address-row">
      <mat-form-field
        class="cap-alerts-connect-tab__address"
        appearance="outline"
        subscriptSizing="dynamic"
      >
        <input
          matInput
          id="webserviceUrlInput"
          type="text"
          readonly
          [value]="pageService.alertUrl()"
          aria-labelledby="capAddressHeading"
          aria-describedby="capAddressHelper"
        />
        <button
          matIconSuffix
          mat-icon-button
          type="button"
          [focus-outline]="2"
          aria-label="Copy address"
          [disabled]="pageService.readOnly()"
          (click)="pageService.copyAddress()"
        >
          <mat-icon svgIcon="copy" aria-hidden="true" />
        </button>
      </mat-form-field>

      <button
        rv-button
        variant="secondary"
        id="urlResetButton"
        type="button"
        [disabled]="pageService.readOnly()"
        (click)="pageService.resetUrl()"
      >
        Reset URL
      </button>
    </div>

    <p class="cap-alerts-connect-tab__learn-more">
      <a rv-link [href]="helpUrl" target="_blank" rel="noopener noreferrer"
        >Learn more about CAP provider setup<span class="tw-sr-only">
          (opens in a new tab)</span
        ></a
      >
      <mat-icon
        class="cap-alerts-connect-tab__external no-stroke"
        svgIcon="open-in-new"
        aria-hidden="true"
      />
    </p>
  </section>

  <div
    class="cap-alerts-connect-tab__optional"
    role="separator"
    aria-labelledby="capOptionalLabel"
  >
    <span id="capOptionalLabel">Optional</span>
  </div>

  <section
    class="tw-flex tw-flex-col tw-gap-4"
    aria-labelledby="capAuthHeading"
  >
    <div class="tw-flex tw-flex-col tw-gap-2">
      <h4 id="capAuthHeading" class="cap-alerts-connect-tab__label">
        Provider authentication
      </h4>
      <p class="cap-alerts-connect-tab__helper">
        Leave these blank if your provider does not ask for credentials.
      </p>
    </div>

    <div class="tw-flex tw-flex-col tw-gap-2">
      <label class="cap-alerts-connect-tab__label" for="usernameInput"
        >Name</label
      >
      <mat-form-field appearance="outline" subscriptSizing="dynamic">
        <input
          matInput
          id="usernameInput"
          type="text"
          autocomplete="off"
          placeholder="Enter name"
          [formControl]="pageService.form.controls.userName"
        />
      </mat-form-field>
    </div>

    <div class="tw-flex tw-flex-col tw-gap-2">
      <label class="cap-alerts-connect-tab__label" for="passwordInput"
        >Password</label
      >
      <mat-form-field appearance="outline" subscriptSizing="dynamic">
        <input
          matInput
          id="passwordInput"
          type="password"
          autocomplete="new-password"
          placeholder="Enter password"
          [formControl]="pageService.form.controls.password"
        />
      </mat-form-field>
    </div>
  </section>
</div>
